import { CtaCard } from '@web/shared/ui';

export const META_DATA = {
	title: 'Take Our Degree Course Quiz!',
	desc: "Unsure what to study at university? You're in the right place! Uni Compare's Degree Quiz will use your answers to find the right course for you.",
};

export const OVERVIEW = {
	title: 'Find the right degree course for you',
	desc: 'Make your course choice with confidence! Take our Degree Course quiz and whittle down your options in a matter of minutes. We’ll send you a list of potential courses we believe are the perfect match for you. ',
};

export const CHOOSE_QUIZ_CONTENT = {
	title: 'Choose the quiz for you!',
	options: [
		{
			title: 'Take our quick assessment',
			desc: 'Looking for a speedy way to decide the right course for you? Complete these quick questions and unlock your matches!',
			image: '/assets/img/quiz_quick_cta.png',
			link: '/degree-quiz/quick-quiz',
			external: false,
		},
		{
			title: 'Take our full assessment',
			desc: "Get into the nitty-gritty of what exactly it is you're looking for in a degree. Take this version of the quiz and find your perfect course match.",
			image: '/assets/img/quiz_full_cta.png',
			link: '/degree-quiz/full-quiz',
			external: false,
		},
	] as CtaCard[],
};

export const POPULAR_SEARCH_CONTENT = {
	title: 'Browse hundreds of degrees',
	desc: 'From institutions up and down the country, explore what each university has to offer with all types of degrees!',
};

export const GUIDE_SLUGS = [
	'philosophy-degree',
	'anthropology-degree',
	'civil-engineering-degree',
	'sociology-degree',
	'psychology-degree',
	'marketing-degree',
];
